var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "symc_right" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "symcr_notice" }, [
      _c("div", { staticClass: "symcr_notice_title" }, [_vm._v("最新通知")]),
      _vm._v(" "),
      _c("div", { staticClass: "symcr_notice_main" }, [
        _c(
          "ul",
          { staticStyle: { height: "231px" } },
          [
            _c(
              "marquee",
              {
                staticStyle: { height: "218px" },
                attrs: {
                  direction: "up",
                  scrolldelay: "150",
                  scrollamount: "1"
                }
              },
              _vm._l(_vm.jxjytzggList, function(item, index) {
                return _c(
                  "li",
                  { key: item.id },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          target: "_blank",
                          to: { path: "/newsInfo", query: { id: item.id } },
                          title: item.newsTitle
                        }
                      },
                      [_vm._v(_vm._s(item.newsTitle))]
                    )
                  ],
                  1
                )
              }),
              0
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "symcr_quick" }, [
      _c(
        "ul",
        [
          _vm._m(1),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _c(
            "el-tooltip",
            { attrs: { content: " 敬请期待 ", placement: "top" } },
            [
              _c("li", [
                _c("a", { attrs: { href: "javascript:;", target: "_blank" } }, [
                  _c("img", {
                    attrs: {
                      src: require("../assets/img/right_pic_02.jpg"),
                      alt: "市级CME项目网上申报及信息反馈系统",
                      width: "225",
                      height: "75"
                    }
                  })
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _vm._m(4),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              { attrs: { href: _vm.TEACH_ADMIN_URL, target: "_blank" } },
              [
                _c("img", {
                  attrs: {
                    src: require("../assets/img/right_pic_061.jpg"),
                    alt: "市级学分平台管理员入口",
                    width: "225",
                    height: "75"
                  }
                })
              ]
            )
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "symcr_live" }, [
      _c(
        "a",
        {
          attrs: {
            href: "https://zb.yiboshi.com/Account/Login",
            target: "_blank"
          }
        },
        [
          _c("img", {
            attrs: {
              src: require("../assets/img/live_img.jpg"),
              alt: "点击进入十堰继教直播平台",
              width: "230",
              height: "67"
            }
          })
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        { attrs: { href: "http://cmegsb.cma.org.cn/", target: "_blank" } },
        [
          _c("img", {
            attrs: {
              src: require("../assets/img/right_pic_01.jpg"),
              alt: "国家级CME项目网上申报及信息反馈系统",
              width: "225",
              height: "75"
            }
          })
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        {
          attrs: {
            href: "http://www.hbma.org.cn/ma/login.asp",
            target: "_blank"
          }
        },
        [
          _c("img", {
            attrs: {
              src: require("../assets/img/right_pic_011.jpg"),
              alt: "武汉CME项目网上申报，申报，审批，公布系统",
              width: "225",
              height: "75"
            }
          })
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        { attrs: { href: "http://kjpt.91huayi.com/", target: "_blank" } },
        [
          _c("img", {
            attrs: {
              src: require("../assets/img/right_pic_04.jpg"),
              alt: "科教管理平台单位版",
              width: "225",
              height: "75"
            }
          })
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        { attrs: { href: "http://kjptwsw.91huayi.com", target: "_blank" } },
        [
          _c("img", {
            attrs: {
              src: require("../assets/img/right_pic_05.jpg"),
              alt: "科教管理平台学员版",
              width: "225",
              height: "75"
            }
          })
        ]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06a12108", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06a12108","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LatestNewsSimple.vue
// module id = null
// module chunks = 